import { RatingTicketPhase } from '../../types/Rating/RatingTypes';

export const isCompletionPhase = (
  ticketPhase?: RatingTicketPhase | null,
): boolean => ticketPhase === 'COMPLETION';
